/**
 * Componente que renderiza los álbumes permanentes del sistema.
 * Adaptado para la web.
 */

import React, { useState } from 'react';
import AlbumManager from './AlbumManager';

/**
 * Lista de álbumes permanentes del sistema.
 * Estos álbumes no se pueden eliminar y tienen límites específicos.
 */
const PERMANENT_ALBUMS = [
  { name: 'fotosDePerfil', displayName: 'Fotos de Perfil', description: 'Máximo 6 imágenes', maxLimit: 6 },
  { name: 'privado-1', displayName: 'Privado', description: 'Máximo 50 imágenes', maxLimit: 50 }
];

/**
 * Componente PermanentAlbums
 *
 * Renderiza los álbumes permanentes del sistema.
 *
 * @param {boolean} indiscreto - Indica si mostrar en modo indiscreto (expandido)
 * @param {Function} onEmptyStatusChange - Callback cuando cambia el estado de vacío de un álbum
 * @param {boolean} isSelectable - Indica si el álbum está en modo de selección (para enviar imágenes por chat)
 * @param {Function} selectableAction - Función a ejecutar cuando se realiza la acción de selección
 * @param {string} selectableTitle - Título para el modo de selección
 * @param {string} selectableDescription - Descripción para el modo de selección
 */
export default function PermanentAlbums({
  indiscreto = false,
  onEmptyStatusChange,
  isSelectable = false,
  selectableAction = null,
  selectableTitle = 'Seleccionar',
  selectableDescription = 'Selecciona imágenes',
  selectionList = [],
  setSelectionList
}) {
  // Estado local para cuando no se proporciona selectionList del padre
  const [privateSelection, setPrivateSelection] = useState([]);

  // Usar el selectionList del padre si está disponible, sino usar estado local
  const effectiveSelectionList = setSelectionList ? selectionList : privateSelection;
  const effectiveSetSelectionList = setSelectionList || setPrivateSelection;

  return (
    <div>
      {PERMANENT_ALBUMS.filter(album => album.name !== 'fotosDePerfil').map(album => (
        <AlbumManager
          key={album.name}
          sectionName={album.displayName}
          album={album.name}
          maxLimit={album.maxLimit}
          selectionList={effectiveSelectionList}
          setSelectionList={effectiveSetSelectionList}
          onDeleteComplete={() => effectiveSetSelectionList([])}
          onEmptyStatusChange={onEmptyStatusChange}
          indiscreto={indiscreto}
          isSelectable={isSelectable}
          selectableAction={selectableAction}
          selectableTitle={selectableTitle}
          selectableDescription={selectableDescription}
        />
      ))}
    </div>
  );
}

export { PERMANENT_ALBUMS };
